// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ig-6";
export var emphasizeQuantity = "_ig-3";
export var flatBottomCorners = "_ig-5";
export var productImage = "_ig-0";
export var quantityContainer = "_ig-2";
export var tooltip = "_ig-1";
export var wrapAndEllipsesOverflow = "_ig-4";